
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["flattenUserGroupServices","filterServices","uniqueServiceFilters","calculateServiceTotals"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "417b1942e5964714386b.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			